import { AuthPermissionsRequest } from "services/Auth/types";
import { useAppDispatch, useAppSelector } from "stores";
import { refetchUserPermissionsAction } from "stores/Auth";

const usePermission = () => {
  const dispatch = useAppDispatch();
  const { userProfile } = useAppSelector((state) => state.auth);

  const canAccess = (permission: string) => {
    if (!userProfile) return false;
    return (
      userProfile.isSuperAdmin ||
      userProfile.permissions.some((p) => p === permission)
    );
  };

  const refetchUserPermissions = (params?: AuthPermissionsRequest) => {
    if (!params) return;
    dispatch(refetchUserPermissionsAction(params));
  };

  return {
    canAccess,
    refetchUserPermissions,
  };
};

export default usePermission;
